import { useAuth } from "@/core/components/auth/store/auth";
import { useSidebar } from "@/_old/components/ui/sidebar";
import KeyboardDoubleArrowRight from "@/_old/assets/icons/sidebar/keyboard_double_arrow_right.svg?react";
import KeyboardDoubleArrowLeft from "@/_old/assets/icons/sidebar/keyboard_double_arrow_left.svg?react";
import { useActionsTrack } from "@/_old/features/analytics";

export function SidebarContentHeader() {
  const { userInfo, hasPermission } = useAuth();

  const { state, toggleSidebar, isMobile } = useSidebar();

  const { onActionClick } = useActionsTrack();

  const isCollapsed = state === "collapsed";

  const hasGroupsPermissioms = hasPermission("read-company-groups");

  return (
    <>
      <div className="mb-6">
        <div className="flex items-center justify-between rounded-lg">
          <div
            className={`flex items-center gap-3 ${isCollapsed ? "flex-col" : ""}`}
          >
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-black">
              W
            </div>

            {isCollapsed && !isMobile ? (
              <div className="mt-2">
                <KeyboardDoubleArrowRight
                  onClick={() => {
                    onActionClick("MENU_SIDEBAR_EXPAND_CLICK", "MENU");

                    toggleSidebar();
                  }}
                  className="h-5 w-5 text-gray-400 cursor-pointer"
                />
              </div>
            ) : null}

            {!isCollapsed && (
              <div>
                <div className="font-semibold text-primary text-sm">
                  {userInfo.league?.name}
                </div>
                {!hasGroupsPermissioms ? (
                  <div className="text-muted-foreground text-xs">
                    {userInfo.user.group?.name}
                  </div>
                ) : null}
              </div>
            )}
          </div>

          {!isCollapsed && !isMobile ? (
            <KeyboardDoubleArrowLeft
              onClick={() => {
                onActionClick("MENU_SIDEBAR_COLLAPSE_CLICK", "MENU");

                toggleSidebar();
              }}
              className="h-5 w-5 text-gray-400 cursor-pointer"
            />
          ) : null}
        </div>
      </div>
    </>
  );
}
